import { IconHome } from "@tabler/icons-react";

export const MAIN_ROUTES = [
  // {
  //   title: "진행중인 과제",
  //   url: "/",
  //   transparent: true,
  //   footer: true,
  //   icon: <IconHome size={18} />,
  // },
  // {
  //   title: "종료된 과제",
  //   url: "/finished",
  //   transparent: false,
  //   footer: true,
  // },
  // {
  //   title: "문의하기",
  //   url: "/support",
  //   transparent: false,
  //   footer: false,
  // },
  // {
  //   title: "마이페이지",
  //   url: "/mypage",
  //   transparent: false,
  //   footer: false,
  // },
  // {
  //   title: "NO SLASH",
  //   url: "api",
  //   transparent: true,
  // },
  // {
  //   title: "관리자",
  //   url: "admin",
  // },
];
